<template>
  <div class="proxy-execution bg-bg-common-color p-4 relative flex flex-col" style="height: calc(100vh - 80px)">
    <!-- 最上面的一个 banner 图 -->
    <!-- <div class="banner">
      <img src="@/assets/img/proxy-execution/topBanner.png" />
    </div> -->
    <!-- 三张小图 -->
    <!-- <div class="flex-none">
       <el-row class="pictures pb-4 flex-none" :gutter="16">
        <el-col :span="8" class="pic inline-block">
          <img src="@/assets/img/proxy-execution/1.png" width="100%" height="100%" @click="creatProxy"/>
        </el-col>
        <el-col :span="8" class="pic inline-block">
          <img src="@/assets/img/proxy-execution/2.png" width="100%" height="100%" @click="recuitment"/>
        </el-col>
        <el-col :span="8" class="pic inline-block">
          <el-popover
            ref="popover1"
            placement="right"
            width="220"
            popper-class="cus-popover"
            trigger="hover"
          >
            <div>
              <p>
                1.添加微信好友
                <img :src="baseUrl+'img/code/Customer.Service.png'" alt="" class="qr-code" />
              </p>
              <p>2.沟通需求</p>
              <p>3.下单</p>
              <p>4.回收成果</p>
              <p>5.售后沟通</p>
              <p style="padding-bottom: 10px">6.结束</p>
            </div>
            <img slot="reference" src="@/assets/img/proxy-execution/3.png" width="100%" height="100%"/>
          </el-popover>
        </el-col>
      </el-row>
    </div>-->
    <div class="flex justify-between relative flex-grow shadow-theme rounded">
      <div class="wrap-flex-full" style="width: 100%">
        <div class="bg-white h-full rounded">
          <div class="absoule-btn">
            <el-button v-show="flag" type="text" @click="handlerManualReviewFlag">委托代理审核</el-button>
            <el-button v-show="flag" type="primary" @click="creatProxy">添加代理</el-button>
          </div>

          <!-- 下面的表格 -->
          <!-- <el-menu :default-active="activeIndex" class="el-menu-demo rounded-t" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">
              <el-badge class="item">选中的代理</el-badge>
            </el-menu-item>
            <el-menu-item index="2">
              <el-badge class="item" :value="handlerSum">报名的代理</el-badge>
            </el-menu-item>
          </el-menu> -->
          <!-- 选中的调查员表格 -->
          <selected-interviewer
            v-if="activeIndex === '1'"
            class="mt-4"
            :inputPlaceholder="inputPlaceholderOptions"
            :taskStatus="taskStatusOptions"
            :tableColumnName="tableColumnNameOptions"
            :propTableData="tableData"
            :combineField="combineFieldOptions"
            @inputValueChange="getTableData"
            :switchChangeFunc="openClose"
            :parseParamsFunc="parseParams"
            :successFunc="successHandler"
            :newField="newFieldOptions"
            :addArrangeParams="addArrangeParamsHandler"
            @sendSomeInfo="rememberRowInfo"
            :createTaskFunc="wjentrusttask"
            channel="proxy"
            :searchRight="false"
            @flag="getflag"
            :total="total"
            :isShowRightAdv="1"
          />

          <signup-proxy v-else-if="activeIndex === '2'" @handlerSum="handlerSumHandler" />
        </div>
        <div class="right-box" v-show="flag">
          <div class="right-title">
            <i></i>
            <p>委托<span v-custom="'out_D74'">调研工厂</span>执行任务</p>
          </div>
          <div class="wrap-body">
            <p><span v-custom="'out_D74'">调研工厂</span>团队有超过 12 年的执行经验，承接明察暗访、网络调查、面对面访问等执行任务。</p>
            <h2>我们的优势：</h2>
            <div class="advantage-list">
              <div class="advantage-items">
                <i class="iconfont icon-wancheng"></i>
                <span>我们自有或第三方共建执行团队超 5000 人</span>
              </div>
              <div class="advantage-items">
                <i class="iconfont icon-wancheng"></i>
                <span>执行团队人员覆盖全国所有省份</span>
              </div>
              <div class="advantage-items">
                <i class="iconfont icon-wancheng"></i>
                <span>执行团队成员至少拥有 2 年执行经验</span>
              </div>
              <div class="advantage-items">
                <i class="iconfont icon-wancheng"></i>
                <span>在城市管理、公共服务、社会调查、文化旅游、资源环境等领域已成功超过执行 20000 个项目</span>
              </div>
              <div class="advantage-items">
                <i class="iconfont icon-wancheng"></i>
                <span>您无需自建团队，成本大大降低 20000 个项目</span>
              </div>
            </div>
            <div class="end-text">...</div>
            <div class="more-text">
              <p>更多细节，请查看 <a :href="hrefExe" target="_blank" @click="toEnexe">委托执行介绍</a></p>
              <p>如需咨询，请扫码添加客服咨询</p>
            </div>
            <div class="info">
              <img src="/assets/img/code/Mrs.Chai.png" />
              <div class="contact">
                <p>客服顾问：<span>柴女士</span></p>
                <p>联系电话：<span>18511821229</span></p>
              </div>
            </div>
          </div>
          <div class="right-title">
            <i></i>
            <p>招募代理</p>
          </div>
          <div class="wrap-body">
            <div class="proxy-text">
              <p>代理不足？您可前往 <a href="javascript:" @click="toTask">任务广场</a> 招募代理：</p>
              <p>1、进入 <a href="javascript:" @click="toTask">任务广场</a></p>
              <p>2、点击 【我要发布任务】，任务类型选择【实地调研】，填写招募详情，招募对象选择【代理】并提交。</p>
              <p>3、待任务广场审核通过后，您可甄选已报名的代理。</p>
            </div>
            <div class="bitmap-img" @click="showViewer = true"></div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
    <el-drawer
      title="任务广场招募代理"
      :visible.sync="recruitDrawer"
      size="70%"
      :destroy-on-close="true"
      :before-close="handleRecruitDrawerClose"
    >
      <RecruitmentForm
        @cancel="handleRecruitDrawerClose"
        :surveyId="GlobalConfig.getSurveyId()"
        :pageType="'proxy'"
      ></RecruitmentForm>
    </el-drawer>
    <el-drawer
      title="添加代理"
      :visible.sync="createDrawer"
      size="70%"
      :destroy-on-close="true"
      :before-close="handleCreateDrawerClose"
    >
      <Create @cancel="handleCreateDrawerClose"></Create>
    </el-drawer>
    <!-- 人工审核设置 -->
    <ManualReview
      v-if="ManualReviewFlag"
      :visible="true"
      :auditRa="auditRadio"
      :deadlineR="deadlineRed"
      :deadlineA="deadlineAll"
      :peopleExamine="peopleExamine"
      agentInt="agentInt"
      @close="ManualReviewFlag = false"
      @manual-review="ManualReview"
    />
    <!-- 查看大图 -->
    <el-image-viewer
      v-if="showViewer"
      :initialIndex="0"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="viewerUrl"
      :z-index="5000"
    />
  </div>
</template>

<script>
import { agencyList, openClose, wjentrusttask } from '@/api/wenjuan/publishQuestion.js'
import selectedInterviewer from '../offline/components/SelectedInterviewer.vue'
import { inputPlaceholderOptions, taskStatusOptions, tableColumnNameOptions, newFieldOptions } from './option.js'
import signupProxy from './components/SignupProxy.vue'
import { getAgencyTaskList, agencyListProxy } from '@/api/wenjuan/offline.js'
import GlobalConfig from '@/global/config'
import RecruitmentForm from '@/views/survey/offline/components/RecruitmentForm'
import Create from './components/Create'
import { toTaskSquare } from '@/assets/js/base-platform.js'
import { agencyListDl } from '@/api/wenjuan/publishQuestion'
import ManualReview from '@/components/manual-review/ManualReview.vue'
import { preWj } from '@/api/wenjuan/wjquestion.js'
import { SURVEY_PUBLISH_STATUS } from '@/global/config-variable.js'
import { saveSurveySetting } from '@/api/wenjuan/publish.js'
import ElImageViewer from 'dygc-ui/packages/image/src/image-viewer'
import { getBaseDomain } from '@/assets/js/config/env'

export default {
  components: {
    selectedInterviewer,
    signupProxy,
    RecruitmentForm,
    Create,
    ManualReview,
    ElImageViewer
  },
  data() {
    return {
      GlobalConfig,
      createDrawer: false,
      recruitDrawer: false,
      activeIndex: '1',
      inputPlaceholderOptions: {},
      taskStatusOptions: [],
      tableColumnNameOptions: {},
      hasProxy: Boolean,
      tableData: [],
      combineFieldOptions: {
        name: 'agentName',
        concat: 'phone',
        id: 'taskId'
      },
      openClose: new Function(),
      newFieldOptions: {},
      row: '',
      wjentrusttask: new Function(),
      total: 0,
      handlerSum: '',
      flag: true,
      ManualReviewFlag: false, // 人工审核开关
      auditRadio: '',
      deadlineRed: 2,
      deadlineAll: 2,
      peopleExamine: false,
      viewerUrl: [require('@/assets/img/wj/taksSquare.png')],
      showViewer: false
    }
  },
  methods: {
    handlerManualReviewFlag() {
      this.ManualReviewFlag = true
      this.preWj()
    },
    getParams(v, n) {
      let params = {
        id: GlobalConfig.getSurveyId(),
        otherSetting: {}
      }
      params.otherSetting[n] = v
      return params
    },
    ManualReview(value, string) {
      // 判断是否由子组件调用
      let val, str, flag, obj
      if (typeof value === 'object') {
        flag = value.val
        obj = this.getParamsManRev(value)
      } else {
        val = value
        str = string
        obj = this.getParams(val, str)
      }
      saveSurveySetting(obj)
        .then(res => {
          this.$message.success('答卷回收渠道保存成功!')
          if (typeof value === 'object') this.peopleExamine = flag
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },
    getParamsManRev(value) {
      let { enableNetManualAudit = value.val, auditRadio, deadlineRed, deadlineAll } = value.auditRadioP
      let params = { id: GlobalConfig.getSurveyId() }
      if (enableNetManualAudit) {
        if (auditRadio == 'enableAuditForRedEnvelopes') {
          params.otherSetting = {
            enableNetManualAudit: true,
            enableAuditForRedEnvelopes: true,
            auditForRedEnvelopesAutoPassTime: deadlineRed
          }
        } else {
          params.otherSetting = {
            enableNetManualAudit: true,
            enableAuditForRedEnvelopes: false,
            auditForRedEnvelopesAutoPassTime: deadlineAll
          }
        }
      } else {
        params.otherSetting = { enableNetManualAudit: false }
      }
      return params
    },
    preWj() {
      const setComponentParams = params => {
        const { auditRadio = 'enableNetManualAudit', deadlineRed = 2, deadlineAll = 2, peopleExamine } = params
        ;[this.auditRadio, this.deadlineRed, this.deadlineAll, this.peopleExamine] = [
          auditRadio,
          deadlineRed,
          deadlineAll,
          peopleExamine
        ]
      }
      preWj(GlobalConfig.getSurveyId()).then(res => {
        // 处理开关状态及抽屉组件传参
        const otherSetting = res.data.data.otherSetting
        if (otherSetting.enableAuditForRedEnvelopes && otherSetting.enableNetManualAudit) {
          setComponentParams({
            auditRadio: 'enableAuditForRedEnvelopes',
            deadlineRed: otherSetting.auditForRedEnvelopesAutoPassTime,
            peopleExamine: true
          })
        } else if (otherSetting.enableNetManualAudit && !otherSetting.enableAuditForRedEnvelopes) {
          setComponentParams({
            deadlineAll: otherSetting.auditForRedEnvelopesAutoPassTime,
            peopleExamine: true
          })
        } else if (!otherSetting.enableNetManualAudit) {
          setComponentParams({ peopleExamine: false })
        }
      })
    },
    getflag(v) {
      this.flag = v
    },
    recuitment() {
      this.recruitDrawer = true
      //this.$router.push(`/survey/${GlobalConfig.getSurveyId()}/offline/random-interview/recruit?pageType=proxy`)
    },
    handleRecruitDrawerClose() {
      this.recruitDrawer = false
      this.getTableData()
    },
    handleSelect(index) {
      index == 1 && this.getTableData()
      this.activeIndex = this.activeIndex == '1' ? '2' : '1'
    },
    handleCreateDrawerClose() {
      this.createDrawer = false
      this.getTableData()
    },
    creatProxy() {
      function alertMsg() {
        this.$alert('您还未委托过代理执行调查任务，您可以去任务广场招募代理或全程委托调研工厂执行。', '提示', {
          confirmButtonText: '确定'
        })
      }
      this.createDrawer = true

      // agencyListDl().then(res => {
      //   if(res.data.data.records && res.data.data.records.length > 0){
      //     this.createDrawer = true

      //   }else{
      //     alertMsg.call(this)
      //   }
      // }).catch(err => {
      //   // alertMsg.call(this)
      //   this.$message({
      //     type: 'error',
      //     message: err.message
      //   });
      // })
    },
    // 处理tableList数据 添加rowspan
    handleTableData(dataList) {
      // 需要去重的数组
      let repeatField = []
      dataList.forEach(item => {
        repeatField.push(item.agentName)
      })
      repeatField = [...new Set(repeatField)]
      dataList.forEach((it, i, arr) => {
        repeatField.forEach(itField => {
          if (itField === it.agentName) {
            it.rowspan = arr.filter(itemFilter => itemFilter.agentName === itField).length
          }
        })
      })
      console.log(dataList)
    },
    getTableData(temParams) {
      let defaultParams = {
        surveyId: GlobalConfig.getSurveyId(),
        current: 1,
        size: 20
      }
      let params = Object.assign({}, defaultParams)
      if (temParams) {
        temParams.commonName && (params.agentName = temParams.commonName)
        temParams.commonPhone && (params.agentName = temParams.commonPhone)
        temParams.commonTaskName && (params.taskName = temParams.commonTaskName) // 任务名称还不能查 等添加接口字段再改
        temParams.taskStatusValue && (params.taskStatus = temParams.taskStatusValue)
        params.current = temParams.current
      }

      agencyList(params).then(res => {
        console.log('res: ', res.data.data.total)

        this.total = res.data.data.total
        // this.total = 100;
        // 处理数据
        // 在每条数据上加上 show 和 edit 字段 之后表格操作会用到
        this.tableData = res.data.data.records.map(item => {
          // 新增的两个字段
          item.show = false
          item.edit = true

          // 修改字段 变成组件统一的 prop
          item.equalName = item.agentName
          item.equalPhone = item.phone
          item.equalTaskName = item.taskName
          item.equalState = item.taskStatus
          item.equalTaskEndTime = item.endTime
          item.equalCount = item.requireCount
          item.equalPrice = item.unitPrice
          item.equalCommitCount = item.submitCount
          item.equalEffectiveCount = item.effectiveAmount
          // mock数据
          // item.settleMode = 3;
          // item.settleRule = {
          //   "tiers": [
          //     {
          //       "unitPriceYuan": 10,
          //       "quantityLowerBound": 1,
          //       "quantityUpperBound": 100
          //     },
          //     {
          //       "unitPriceYuan": 20,
          //       "quantityLowerBound": 100,
          //       "quantityUpperBound": 200
          //     },
          //     {
          //       "unitPriceYuan": 30,
          //       "quantityLowerBound": 200,
          //       "quantityUpperBound": 300
          //     }
          //   ],
          //   "unitPriceYuan": 1,
          //   "expectedQuantity": 1
          // }

          if (item.taskStatus == 3 || item.taskStatus == 4) {
            item.isOpen = true
          } else {
            item.isOpen = false
          }
          return item
        })
        this.handleTableData(this.tableData)
      })
    },
    parseParams(row) {
      // console.log('row: ', row);
      let isClosed = row.taskStatus === 6 ? 0 : 1
      return {
        taskId: row.taskId,
        isClosed
      }
    },
    successHandler(row) {
      let status = row.taskStatus === 6 ? 3 : 6
      row.taskStatus = status
      row.isClosed = !row.isClosed
    },
    addArrangeParamsHandler(data) {
      return {
        taskName: data.equalTaskName,
        unitPrice: data.equalPrice,
        requireCount: data.equalCount,
        endTime: data.equalTaskEndTime,

        relationId: this.row.relationId,
        agentId: this.row.agentId,
        agentType: this.row.agentType,
        agentName: data.agentName,

        phone: data.phone,

        surveyId: GlobalConfig.getSurveyId(),
        agencyApproveFlag: 1,
        qualityControlStandard: '',
        settleStandard: ''
      }
    },
    rememberRowInfo(row) {
      this.row = row
    },
    init() {
      // 导入配置文件
      this.inputPlaceholderOptions = inputPlaceholderOptions
      this.taskStatusOptions = taskStatusOptions
      this.tableColumnNameOptions = tableColumnNameOptions
      this.openClose = openClose
      this.newFieldOptions = newFieldOptions
    },
    // 【未处理数】的处理函数
    handlerSumHandler(handlerSum) {
      this.handlerSum = handlerSum
    },
    // 跳转到任务广场
    toTask() {
      toTaskSquare()
    },
    // 跳转到委托执行页
    toEnexe() {
      // window.open(process.env.VUE_APP_DYGC_BASE_DOMAIN + '/entrustexe')
    }
  },
  computed: {
    hrefExe() {
      return getBaseDomain() + '/entrustexe'
    }
  },
  async created() {
    this.init()
    this.getTableData()
    this.preWj()

    let res = await getAgencyTaskList({
      surveyId: GlobalConfig.getSurveyId()
    })
    let count = 0
    res.data.data &&
      res.data.data.forEach(item => {
        item.agencyList &&
          item.agencyList.forEach(n => {
            if (n.shopHasProxyJobStatus == 100) {
              count++
            }
          })
      })
    this.handlerSum = count == 0 ? '' : count
    this.wjentrusttask = wjentrusttask
  }
}
</script>

<style lang="scss" scoped>
.proxy-execution {
  padding: 0;
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  ::v-deep .el-badge__content.is-fixed {
    position: absolute;
    top: 15px;
    right: -1px;
  }
  .pictures {
    cursor: pointer;
    // .pic:nth-child(1) {
    //   @apply -mb-0.5;
    // }
    // .pic:nth-child(2) {
    //   @apply mb-4;
    // }
    // .pic:nth-child(1) {
    //   // width: 300px;
    //   height: 100px;
    // }
    // .pic:nth-child(2) {
    //   // width: 295px;
    //   height: 115px;
    //   margin-top: -15px;
    // }
    // .pic:nth-child(3) {
    //   // width: 295px;
    //   height: 100px;
    // }
    img {
      // width: 100%;
      height: 100%;
    }
  }

  .basic-content {
    ::v-deep .el-card__body {
      min-height: calc(100vh - 440px) !important;
    }
  }
  .el-menu-demo.el-menu--horizontal {
    .el-menu-item.is-active {
      @apply text-theme;
    }
    .el-menu-item:not(.is-disabled):hover {
      @apply text-theme;
    }
  }
}
.cus-popover {
  width: 220px !important;
  margin: auto;
  div {
    position: relative;
    left: 23px;
  }
  p {
    display: block;
    width: auto;
    opacity: 0.85;
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    line-height: 24px;
    padding-top: 10px;
  }
  .qr-code {
    width: 150px;
    height: 150px;
    display: block;
  }
}

.wrap-flex-full {
  display: flex;
  background: rgb(247, 249, 251);
  overflow: hidden;
  .bg-white {
    overflow: hidden;
    flex: 1;
    position: relative;
    margin: 16px;
    height: calc(100% - 32px);
    .absoule-btn {
      position: absolute;
      right: 32px;
      top: 16px;
      z-index: 99;
    }
  }
  .right-box {
    width: 290px;
    height: calc(100vh - 80px);
    border-left: 1px solid #e7e9eb;
    background: #fff;
    overflow: auto;
    .right-title {
      margin-top: 16px;
      display: flex;
      i {
        width: 4px;
        height: 20px;
        @apply bg-theme;
      }
      p {
        margin-left: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .wrap-body {
      padding: 0 16px 0 24px;
      p {
        margin-top: 8px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        letter-spacing: 0;
        line-height: 24px;
      }
      h2 {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        letter-spacing: 0;
        line-height: 24px;
        margin-top: 8px;
        margin-bottom: 4px;
      }
      .advantage-list {
        display: flex;
        flex-direction: column;
        .advantage-items {
          display: flex;
          margin-bottom: 8px;
          i {
            color: #55bb72;
            margin-top: 4px;
          }
          span {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 24px;
            margin-left: 6px;
          }
        }
      }
      .end-text {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 24px;
        padding-left: 22px;
        margin-bottom: 13px;
      }
      .more-text {
        margin-bottom: 8px;
        p {
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          letter-spacing: 0;
          line-height: 24px;
          a {
            @apply text-theme;
          }
        }
      }
      .info {
        @apply flex justify-between mt-2;
        padding-bottom: 16px;
        border-bottom: 1px solid #e7e9eb;
        img {
          @apply w-w-22 h-h-22 mr-4;
        }
        .contact {
          @apply flex-1 flex flex-col justify-center;
          p {
            height: 22px;
            color: rgba($color: #000000, $alpha: 0.45);
            @apply font-normal text-small leading-22;
            span {
              color: rgba($color: #000000, $alpha: 0.85);
            }
          }
          & p:last-child {
            @apply mt-2;
          }
        }
      }
      .proxy-text {
        p {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 24px;
          a {
            @apply text-theme;
          }
        }
      }
      .bitmap-img {
        margin-top: 8px;
        margin-bottom: 8px;
        width: 100%;
        height: 232px;
        background: url('../../../assets/img/wj/bitmap.png');
        background-size: 100%;
        cursor: pointer;
      }
    }
  }
}
</style>
